const fs = require('fs')

import m from 'mithril';
import {trans} from "./helpers";
const faSearch = fs.readFileSync('css/icons/search-solid.svg', 'utf-8');

class SelectTypeahead {
    oncreate(vnode) {
        this.el = vnode.dom;
    }

    oninit(vnode) {
        this.typeahead_state = {
            listMode: true,
            query: '',
            visible: false,
            timeout: null,

            getData: null,
            getItemText: null,
            getItemId: null,
            onItemSelect: null,
            onItemSelectParams: null,

            selected: null,

            list: null,
            selectedItems: null,

            data_state: {
                results: [],
                is_loading: false,
            },

            placeholder: '',
            no_results_text: 'No results',
            value: null,
            opened: false,
        }


        this.typeahead_state.getData = vnode.attrs.getData;
        this.typeahead_state.getItemText = vnode.attrs.getItemText;
        this.typeahead_state.getItemId = vnode.attrs.getItemId;
        this.typeahead_state.onItemSelect = vnode.attrs.onItemSelect;
        this.typeahead_state.onItemSelectParams = vnode.attrs.onItemSelectParams;
        this.typeahead_state.onClose = vnode.attrs.onClose;
        this.typeahead_state.onChange = vnode.attrs.onChange;
        this.typeahead_state.placeholder = vnode.attrs.placeholder;
        this.typeahead_state.getValue = vnode.attrs.getValue;
        this.typeahead_state.list = vnode.attrs.list;
        this.typeahead_state.listMode = vnode.attrs.listMode;
        this.typeahead_state.selectedItems = vnode.attrs.selectedItems; // MUST HAVE 'list' ATTRIBUTE!
        this.typeahead_state.type = vnode.attrs.type; // (checkbox, radio)
        this.typeahead_state.dimPlaceholder = vnode.attrs.dimPlaceholder; 

        // console.log(this.selectedItems);

        this.typeahead_state.selectedItemsToShow = [];

        if (vnode.attrs.noResultsText)
            this.typeahead_state.no_results_text = vnode.attrs.noResultsText;

        if (!this.typeahead_state.type)
            this.typeahead_state.type = 'checkbox';

        if (!vnode.attrs.getValue) 
            this.typeahead_state.getValue = _ => null;

        if (!('dimPlaceholder' in vnode.attrs)) 
            this.typeahead_state.dimPlaceholder = true;
    }

    onSelect(i, state) {
        if (i == null || i < 0 || i > state.data_state.results.length-1)
            return

        state.visible = false;

        let selectedElement = state.data_state.results[i];

        state.onItemSelect(selectedElement, state.onItemSelectParams);

        state.value = state.getValue();
        m.redraw();
    }

    moveSelected(e) {
        let keyCode = e.keyCode;

        if (keyCode == 38) {
            if (this.typeahead_state.selected == null) {
                this.typeahead_state.selected = 0;
            } else if (this.typeahead_state.selected >= 1) {
                this.typeahead_state.selected = this.typeahead_state.selected - 1;
            }
        }

        if (keyCode == 40) {
            if (this.typeahead_state.selected == null) {
                this.typeahead_state.selected = 0;
            } else if (this.typeahead_state.selected < this.typeahead_state.data_state.results.length - 1 ) {
                this.typeahead_state.selected = this.typeahead_state.selected + 1;
            }
        }


        let element = this.el.querySelector('.typeahead').children.item(this.typeahead_state.selected);
        let container = element.parentElement;

        let cTop = container.scrollTop;
        let cBottom = cTop + container.clientHeight;

        let eTop = element.offsetTop;
        let eBottom = eTop + element.clientHeight;

        if (eTop < cTop) {
            container.scrollTop -= (cTop - eTop);
        }
        else if (eBottom > cBottom) {
            container.scrollTop += (eBottom - cBottom);
        }

        m.redraw();
    }

    getList() {
        let list = this.typeahead_state.list;

        if (typeof list === 'object' && 'list' in list)
            list = list.list;

        return list;
    }

    filterList() {

        let list = this.getList();

        this.typeahead_state.data_state.results = list.filter(i => i.title.toLowerCase().includes(this.typeahead_state.query.toLowerCase()));
        this.typeahead_state.data_state.is_loading = false;
        // this.sortResults();
        m.redraw();
    }

    getResults() {
        this.typeahead_state.data_state.is_loading = true;
        m.redraw();

        if (!this.typeahead_state.listMode) {
            this.typeahead_state.getData(this.typeahead_state.query, this.typeahead_state.data_state);
        } else {
            this.filterList();
        }
    }

    typeaheadPlaceholder() {
        let placeholder_text = this.typeahead_state.placeholder;

        let selected = [];

        let number_of_selected_text = '';

        let has_items_selected = this.typeahead_state.selectedItems.list.length > 0;

        let placeholder_class = this.typeahead_state.dimPlaceholder ? '.select-typeahead-component__placeholder' : '';

        if (has_items_selected) {
            for (var i = 0; i < this.typeahead_state.selectedItems.list.length; i++) {
                let item = this.typeahead_state.selectedItems.list[i];
                selected.push(this.typeahead_state.getItemText(item));
            }

            placeholder_text = selected.join(', ');

            if (this.typeahead_state.selectedItems.list.length > 1) {
                number_of_selected_text += ' (' + (this.typeahead_state.selectedItems.list.length) + ')';
            }

            placeholder_class = '.select-typeahead-component__selected-items';
        }

        return [
            m('.select-typeahead-component__box', {
                onclick: e => {
                    this.typeahead_state.query = '';
                    this.typeahead_state.opened = true;
                    this.typeahead_state.selectedItemsToShow = JSON.parse(JSON.stringify(this.typeahead_state.selectedItems.list));
                    this.getResults();
                    m.redraw();
                },
            }, [   
                m(placeholder_class, placeholder_text),

                (number_of_selected_text.length > 0),
                m('.select-typeahead-component__number-of-selected', number_of_selected_text)
            ])
        ];
    }

    typeaheadInput() {
        return m('.select-list__search', [
            m('.select-list__search__icon', m.trust(faSearch)),
            m('input.select-list__search__input', {
                oncreate: ({dom}) => dom.focus(),
                value: this.typeahead_state.value,
                placeholder: 'Iskalnik',

                onkeyup: e => {
                    let keyCode = e.keyCode;

                    if (keyCode == 38 || keyCode == 40) {
                        e.preventDefault();
                        this.moveSelected(e);
                        return;
                    }

                    if (keyCode == 13) {
                        e.preventDefault();
                        e.target.blur();
                        this.onSelect(this.typeahead_state.selected, this.typeahead_state);
                        return;
                    }

                    this.typeahead_state.query = e.target.value;
                    
                    clearTimeout(this.typeahead_state.timeout);

                    if (this.typeahead_state.listMode) {
                        this.getResults();
                    } else {
                        // this.typeahead_state.data_state.is_loading = true;
                        this.typeahead_state.timeout = setTimeout(e => { 
                            this.getResults();
                        }, 500);
                    }
                },

                onfocus: e => {
                    if (this.typeahead_state.query.length > 0) {
                        this.typeahead_state.value = null;
                        this.typeahead_state.visible = true;
                    }
                },
            }),
        ]);
    }

    typeaheadResults() {
        // let selected_items_to_show = this.typeahead_state.selectedItemsToShow.filter(i => i.title.toLowerCase().includes(this.typeahead_state.query.toLowerCase()));
        let selected_items_to_show = this.typeahead_state.selectedItemsToShow.filter(i => this.typeahead_state.getItemText(i).toLowerCase().includes(this.typeahead_state.query.toLowerCase()));
        let selected_items_ids = selected_items_to_show.map(i => this.typeahead_state.getItemId(i)*1);

        return  m('div', 
            {
                class: 'select-list__list ' + (this.typeahead_state.opened ? '' : 'select-list__list--hidden')
            },
            [
                this.typeahead_state.data_state.is_loading &&
                    m('.select-list-element.select-list-element--loading', ''),

                this.typeahead_state.data_state.results.length > 0 && !this.typeahead_state.data_state.is_loading &&
                [
                    selected_items_to_show.map((item, i) => {
                        return this.typeahead_element(item, i);
                    }),

                    this.typeahead_state.data_state.results.map((item, i) => {
                        if (!selected_items_ids.includes(this.typeahead_state.getItemId(item)*1))
                            return this.typeahead_element(item, i);
                    }),
                ],

                this.typeahead_state.data_state.results.length == 0 && !this.typeahead_state.data_state.is_loading &&
                    m('div.select-list-element.select-list-element--text', this.typeahead_state.no_results_text)
            ]
        );
    }

    toggle_all_items() {
        let list = this.getList();
        
        if (this.typeahead_state.selectedItems.list.length == list.length) {
            this.typeahead_state.selectedItems.list = [];
        } else {
            this.typeahead_state.selectedItems.list = [];
            list.forEach(i => {
                this.typeahead_state.selectedItems.list.push(i);
            });
        }

        if (this.typeahead_state.onChange) {
            this.typeahead_state.onChange();
        }
    }

    toggle_item(item) {

        if (this.is_item_selected(item)) {
            this.typeahead_state.selectedItems.list = this.typeahead_state.selectedItems.list.filter(i => this.typeahead_state.getItemId(i) != this.typeahead_state.getItemId(item));
        } else {
            if (this.typeahead_state.type == 'radio')
                this.typeahead_state.selectedItems.list = [];
                    
            this.typeahead_state.selectedItems.list.push(item);
        }

        if (this.typeahead_state.onChange) {
            this.typeahead_state.onChange();
        }
    }

    is_item_selected(item) {
        return (this.typeahead_state.selectedItems.list.filter(_item => this.typeahead_state.getItemId(_item) == this.typeahead_state.getItemId(item)).length > 0);
    }

    typeahead_element(item, i) {
        return  m('.select-list-element' + (this.typeahead_state.selected != null && this.typeahead_state.selected==i ? '.select-list-element__selected' : ''), {
                    onclick: e => this.toggle_item(item)
                }, [                    
                    m('div.custom-checkbox', [
                        m('input', {
                            type: 'checkbox',
                            checked: this.is_item_selected(item),
                        }),
                        m('span.custom-checkmark'),
                    ]),
                    m('.select-list-element__title', this.typeahead_state.getItemText(item)),
                ]);
    }

    close() {
        this.typeahead_state.opened = false;

        if (this.typeahead_state.onClose) {
            this.typeahead_state.onClose();
        }
    }

    view() {
        return m('.select-typeahead-component', [
            this.typeahead_state.opened &&
            m('.select-typeahead-component__background', {
                onclick: e => this.close()
            }),
            this.typeahead_state.opened &&
            m('div.select-list', [ 
                this.typeaheadInput(),
                this.typeaheadResults()
            ]),
            // !this.typeahead_state.opened &&
            this.typeaheadPlaceholder(),
            
            
        ]);
    }
}

export default SelectTypeahead;